import {useEffect, useState} from "react";
import {Autocomplete, TextField, CircularProgress, useTheme} from '@mui/material';

const VehiclePlateNumberListDropdownComponent = (props) => {
    const {onChange, value, fullWidth, size, customStyles, disabled, isFetchingActiveVehicleList, activeVehicleList, getActiveVehicleList, org_uid} = props;

    const theme = useTheme();

    const [vehicleListData, setVehicleListData] = useState([]);

    const [stateValue, setStateValue] = useState(null);
    const [inputValue, setInputValue] = useState("");
    

    useEffect(() => {
        const parameters = {status: "Active", orgUID: org_uid};
        getActiveVehicleList(parameters);
    }, [])

    useEffect(() => {
        setStateValue(value || null);
        setInputValue(value || "");

        if (activeVehicleList?.length > 0) {
            const formattedPlateNumberList = activeVehicleList?.map(vehicle => vehicle.plate_number);
            const filteredVehicleListData = formattedPlateNumberList?.filter((vehicle) => vehicle?.plate_number !== value);

            setVehicleListData(filteredVehicleListData);
        }
    }, [activeVehicleList, value])


    const handleChange = (newValue) => {
        setStateValue(newValue);
        setInputValue(newValue || "");
        onChange(newValue);
    }

    return (
        <>
            <Autocomplete
                disabled={disabled ? disabled : false}
                disablePortal
                options={vehicleListData}
                getOptionLabel={(option) => option || ""}
                isOptionEqualToValue={(option, value) => option === value}
                fullWidth={fullWidth}
                size={size}
                value={stateValue}
                loading={isFetchingActiveVehicleList}
                onChange={(event, newValue) => handleChange(newValue)}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                noOptionsText="Plate number not found."
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Search plate number"
                        slotProps={{
                            input: {
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {isFetchingActiveVehicleList ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: "4px", 
                                height: "42px",
                                paddingTop: '6px', 

                                '& input': {
                                    color: theme.typography.main,
                                    fontSize: 16,
                                    fontWeight: 500,

                                    '&::placeholder': {
                                        color: theme.typography.secondary,               
                                        opacity: 0.45,    
                                        fontSize: 15,    
                                        fontWeight: "400 !important",                     
                                    },
                                },

                                '& fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&:hover fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&.Mui-focused fieldset': {
                                    borderColor: "#253e5a9e",
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: theme.typography.secondary,               
                                opacity: 0.45,    
                                fontSize: 15,    
                                fontWeight: "400 !important",
                                marginTop: "-5px",
                            },
                        }}
                    />
                )}
                sx={{...customStyles}}
            />
        </>
    )
}

export default VehiclePlateNumberListDropdownComponent